import React from "react";
import Card from "../components/Card";

export default function getHandVisuals(hand, fullRing = false) {
	let handArr = [...hand];
	handArr.shift(); //removes hand strength, leaving just array of individual cards
	let handVis = handArr.map((card, i) => <Card key={card} cardInfo={card} fullRing={fullRing} cardNumber={i} />);
	return handVis;
}
